import PaymentViewIcon from '@material-ui/icons/ViewList';

import PaymentViewList from './PaymentViewList';

export default {
  list: PaymentViewList,
  icon: PaymentViewIcon,
};
